import { FETCH_SESSIONS, GET_SESSIONS } from '../../actions/sessions';

import GetSessions from './helpers/get_sessions';

import FetchSessions from './helpers/fetch_sessions';

export default db => {
  const getSessions = GetSessions(db);
  const fetchSessions = FetchSessions(db);
  return store => next => async action => {
    switch (action.type) {
      case FETCH_SESSIONS:
        return fetchSessions(store, next, action);
      case GET_SESSIONS:
        return getSessions(store, next, action);
      default:
        return next(action);
    }
  };
};
